// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3C8fC","label":"styles_label__35zPv"};